import { handleRequest } from ".";
import { httpAuthorized } from "@/main";

/** 汇率快照行（svc_exchange_rate 表） */
export interface ExchangeRateItem {
  id: string;
  rateDate: string;
  currency: string;
  rate: number;
  updaterId: string;
  createtime: string;
  updatetime: string;
}

/** 支持的币种（ISO 4217 + 符号 + 中文名 + 是否已录汇率快照） */
export interface CurrencyOption {
  code: string;
  symbol: string;
  cname: string;
  hasRate: boolean;
}

/** 查询支持的币种列表（录入下拉用，不含 CNY 基准） */
export const getCurrenciesApi = async (): Promise<CurrencyOption[] | null> => {
  return handleRequest<CurrencyOption[]>(
    httpAuthorized.get("/exchangeRate/currencies"),
    (data) => data.data.currencies ?? []
  );
};

/** 查询汇率快照列表（按生效日期倒序，可按币种过滤） */
export const getExchangeRateListApi = async (
  currency?: string
): Promise<ExchangeRateItem[] | null> => {
  return handleRequest<ExchangeRateItem[]>(
    httpAuthorized.get("/exchangeRate/list", {
      params: currency ? { currency } : {},
    }),
    (data) => data.data.rates ?? []
  );
};

/** 某日期的生效汇率（<= 该日期每币种最新一版，对 CNY） */
export const getEffectiveRatesApi = async (
  date?: string
): Promise<{ date: string; rates: Record<string, number> } | null> => {
  return handleRequest<{ date: string; rates: Record<string, number> }>(
    httpAuthorized.get("/exchangeRate/effective", {
      params: date ? { date } : {},
    }),
    (data) => data.data.result
  );
};

/** 保存一版汇率快照（同日同币种覆盖旧值） */
export const saveExchangeRateApi = async (
  rateDate: string,
  items: { currency: string; rate: number }[]
): Promise<unknown | null> => {
  return handleRequest<unknown>(
    httpAuthorized.post("/exchangeRate/save", { rateDate, items }),
    (data) => data.data.result
  );
};

/** 删除一条汇率快照 */
export const deleteExchangeRateApi = async (
  id: string
): Promise<unknown | null> => {
  return handleRequest<unknown>(
    httpAuthorized.post("/exchangeRate/delete", { id }),
    (data) => data.data.result
  );
};
